/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: User.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * User - Frontend model: User.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

/* START_CLASS_User */
/* START_CONTRACT: User
 * PURPOSE: Клиентская модель пользователя (email, статус, роль, дата регистрации).
 * INPUTS: { email, status, role, registrationDate } или API-ответ через fromResponse.
 * OUTPUTS: экземпляр User.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-USER
 * END_CONTRACT: User
 */
export default class User {
  constructor({ email = '', status = '', role = '', registrationDate = '' } = {}) {
    this.email = email;
    this.status = status;
    this.role = role;
    this.registrationDate = registrationDate;
  }

  static fromResponse(data) {
    return new User({
      email: data.email,
      status: data.status,
      role: data.role ?? '',
      registrationDate: data.registeredAt?.split('T')[0] ?? '',
    });
  }
}
/* END_CLASS_User */
